(ns frontend.view.kpi-reporting.kpi-company-reports.events
  (:require
   [clojure.string :as string]
   [frontend.view.nev.events :as nev-events]
   [potpuri.core :as potpuri :refer [fn-> fn->>]]
   [frontend.utils :as fu]
   [common.localization :as loc]
   [common.util :as cu]
   [promesa.core :as p]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.notification.view :as notification-modal]
   [frontend.view.modals.kpi-email.view :as kpi-email-modal]
   [frontend.view.kpi-reporting.kpi-company-reports.db :as db]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.conn :as conn]
   [frontend.state.current-session :as session]
   [frontend.logging :as logging]
   [frontend.exports.excel :as excel]
   [frontend.actions.common :as common-actions]
   [frontend.actions.attachment :as attachment-actions]))

(defn update-data!
  [id ypkw value]
  (swap! db/state assoc-in (concat [:edit-data id] ypkw) value))

(defn update-answer!
  [id kw value]
  (swap! db/state assoc-in [:edit-answer id kw] value))

;;empty local state for this piece of data
(defn remove-data!
  [id [year month kw]]
  (swap! db/state update-in [:edit-data id year month] dissoc kw))

(defn remove-answer!
  [id kw]
  (swap! db/state update-in [:edit-answer id] dissoc kw))

(defn save-data!
  [kpi-report-id [year month kpi-kw :as ypkw]]
  (let [val (get-in @db/state (concat [:edit-data kpi-report-id] ypkw))
        ;;change float to bigdecimal
        ;;TODO remove conversion when we have a numeric input element that
        ;; uses bigdecs instead of floats
        val (if-not (nil? val)
              (fu/float->bigdec val)
              val)
        msg {:kpi-report-id kpi-report-id
             :year          year
             :period        month
             :kpi           kpi-kw
             :value         val}]
    (when (contains? (get-in @db/state [:edit-data kpi-report-id year month]) kpi-kw)
      (-> (conn/sendp! :kpi-report/update-kpi msg)
          (p/then (fn [_]
                    (remove-data! kpi-report-id ypkw)))
          (p/catch (fn [e]
                     (logging/error "Unable to save kpi" e)))))))
(defn save-answer!
  [kpi-report-id kw]
  (let [val (get-in @db/state [:edit-answer kpi-report-id kw])
        msg {:kpi-report-id kpi-report-id
             :question      kw
             :response      val}]
    (when-not (nil? val)
      (-> (conn/sendp! :kpi-report/answer msg)
          (p/then (fn [_]
                    (remove-answer! kpi-report-id kw)))
          (p/catch (fn [e]
                     (logging/error "Unable to respond kpi-report question" e)))))))

(defn set-mode!
  [mode]
  (reset! db/mode mode))

(defn toggle-sidenav!
  []
  (swap! db/state update :sidenav-minimized? not))

(defn select-cycle!
  [cycle]
  (swap! db/state assoc
    :selected-cycle cycle
    :selected-item :submission-status))

(defn select-item!
  [item]
  (swap! db/state assoc :selected-item item))

(defn disabled-company?
  [{:keys [kpi-report/company] :as kpi-report}]
  (let [e (get @session/entities company)]
    (or (nil? e)
        (:common/disabled? e))))

(defn company-reports
  [company-id]
  (let [compare-report (fn [a b]
                         (let [a-cycle (->> a
                                            :kpi-report/kpi-cycle
                                            (get @session/entities))
                               b-cycle (->> b
                                            :kpi-report/kpi-cycle
                                            (get @session/entities))
                               a-month (:kpi-cycle/target-month a-cycle)
                               b-month (:kpi-cycle/target-month b-cycle)
                               a-year (:kpi-cycle/target-year a-cycle)
                               b-year (:kpi-cycle/target-year b-cycle)
                               a-name (->> a-cycle
                                           :kpi-cycle/kpi-category
                                           (get @session/entities)
                                           :kpi-category/name
                                           str
                                           string/lower-case)
                               b-name (->> b-cycle
                                           :kpi-cycle/kpi-category
                                           (get @session/entities)
                                           :kpi-category/name
                                           str
                                           string/lower-case)
                               name-comparison (compare a-name b-name)
                               year-comparison (compare b-year a-year)
                               month-comparison (compare b-month a-month)]
                           (if-not (zero? name-comparison)
                             name-comparison
                             (if-not (zero? year-comparison)
                               year-comparison
                               month-comparison))))
        reports (->> @session/all-kpi-reports
                     (cu/only-entity :kpi-report/company company-id)
                     (filter :kpi-report/kpi-cycle)
                     (sort-by identity compare-report))]
    reports))

(defn select-company!
  [company-id]
  (let [first-report-id (->> company-id
                             company-reports
                             first
                             :db/id)]
    (swap! db/state assoc
      :loading? true
      :selected-company company-id
      :selected-report first-report-id)))

(defn select-report!
  [report-id]
  (swap! db/state assoc :loading? true)
  (-> (conn/sendp! :kpi-report/load-report {:kpi-report-id report-id})
      (p/then (fn [resp]
                (let [entities (:body resp)]
                  (nev-events/updates-to-session-state entities)
                  (swap! db/state assoc
                    :loading? false
                    :selected-report report-id))))
      (p/catch (fn [e]
                 (swap! db/state assoc :loading? false)
                 (logging/error "Could not load KPI report data")))))

(defn cleanup
  []
  (reset! db/state nil))

(defn setup
  [company-id]
  (when-let [first-report-id (->> company-id
                                  company-reports
                                  first
                                  :db/id)]
    (select-report! first-report-id)))

(defn update-internal-note!
  [kpi-report val]
  (swap! db/state update-in [(:db/id kpi-report)] assoc :internal-note val))

(defn save-internal-note!
  [kpi-report]
  (let [val (-> @db/state
                (get (:db/id kpi-report))
                :internal-note)
        msg {:kpi-report-id (:db/id kpi-report)
             :internal-note val}]
    (when-not (nil? val)
      (-> (conn/sendp! :kpi-report/update msg)
          (p/then (fn [_]
                    (update-internal-note! kpi-report nil)))
          (p/catch (fn [e]
                     (logging/error "Unable to edit kpi-report" e)))))))

(defn save-currency!
  [kpi-report value on-success! on-error!]
  (let [msg {:kpi-report-id (:db/id kpi-report)
             :currency      value}]
    (when-not (nil? val)
      (-> (conn/sendp! :kpi-report/update msg)
          (p/then (fn [_]
                    (on-success!)
                  ))
          (p/catch (fn [e]
                     (on-error!)
                     (logging/error "Unable to edit kpi-report" e)))))))

(defn change-status!
  [report status]
  (let [msg {:kpi-report-id (:db/id report)}
        current-status (:kpi-report/status report)
        handler (cond
                  (and (= current-status :kpi-report.status/reviewed)
                       (= status :kpi-report.status/submitted))
                  :kpi-report/activate
                  (= status :kpi-report.status/submitted)
                  :kpi-report/submit
                  (= status :kpi-report.status/wip)
                  :kpi-report/publish
                  (= status :kpi-report.status/reviewed)
                  :kpi-report/review
                  (= status :kpi-report.status/draft)
                  :kpi-report/unpublish)]
    (-> (conn/sendp! handler msg)
        (p/then (fn [_]
                  (identity 'todo))) ;;do nothing for now
        (p/catch (fn [e]
                   (logging/error (str "status change to " (loc/tr status) " failed") e))))))

(defn reporting-cycle-str
  [kpi-report]
  (let [{:keys [kpi-report/target-month kpi-report/target-year kpi-report/granularity]} kpi-report]
    (str (when (= granularity :quarterly) "Q") target-month "/" target-year)))

;;TODO nylas?
(defn open-email-client!
  [guest-accounts title body]
  (let [account (-> @session/session
                    :account)
        email-bcc (-> account
                      :account/email)
        email-subject (js/encodeURIComponent title)
        email-body (js/encodeURIComponent body)
        email-recipients (map :account/email guest-accounts)
        email-url (str "mailto:" (string/join "," email-recipients)
                       "?&bcc=" email-bcc
                       "&subject=" email-subject
                       "&body=" email-body)]
    #_(.open js/window email-url "_blank")
    (aset js/window.location "href" email-url)))

(defn send-reminder!
  [selected-report]
  (let [selected-report-id (:db/id selected-report)
        selected-company-id (:kpi-report/company selected-report)
        session-entities @session/entities
        category (->> selected-report
                      :kpi-report/kpi-cycle
                      (get session-entities)
                      :kpi-cycle/kpi-category
                      (get session-entities))
        their-contact (->> selected-report
                           :kpi-report/contact-account
                           (get session-entities))
        our-contact (->> selected-report
                         :common/owner
                         (get session-entities))
        their-contact-first-name (:account/first-name their-contact)
        our-contact-first-name (:account/first-name our-contact)
        company-name (->> selected-company-id
                          (get session-entities)
                          :asset/name)]
    (modals/open-modal!
     kpi-email-modal/modal-key
     {:send-text           (loc/tr :send-reminder)
      :email-title-attribute :kpi-report/email-title
      :email-copy-attribute :kpi-report/email-copy
      :default-email-title (loc/tr :kpi-revision-title [company-name]) ;;TODO different default template for reminder?
      :default-email-copy  (loc/tr :kpi-revision-copy
                               [their-contact-first-name our-contact-first-name company-name])
      :report-id           selected-report-id
      :email-to            (:account/email their-contact)
      :send-email!         (fn [{:keys [msg on-success! on-error!]}]
                             (-> (conn/sendp! :kpi-category/send-reminder msg)
                                 (p/then (fn [_]
                                           (on-success!)))
                                 (p/catch (fn [e]
                                            (on-error! e)
                                            (logging/error "send-reminder! failed" e)))))})))

(defn request-revision!
  [selected-report]
  (let [selected-report-id (:db/id selected-report)
        selected-company-id (:kpi-report/company selected-report)
        session-entities @session/entities
        category (->> selected-report
                      :kpi-report/kpi-cycle
                      (get session-entities)
                      :kpi-cycle/kpi-category
                      (get session-entities))
        their-contact (->> selected-report
                           :kpi-report/contact-account
                           (get session-entities))
        our-contact (->> selected-report
                         :common/owner
                         (get session-entities))
        their-contact-first-name (:account/first-name their-contact)
        our-contact-first-name (:account/first-name our-contact)
        company-name (->> selected-company-id
                          (get session-entities)
                          :asset/name)]
    (modals/open-modal!
     kpi-email-modal/modal-key
     {:send-text           (loc/tr :request-revision)
      :email-title-attribute :kpi-report/email-title
      :email-copy-attribute :kpi-report/email-copy
      :default-email-title (loc/tr :kpi-revision-title [company-name])
      :default-email-copy  (loc/tr :kpi-revision-copy
                               [their-contact-first-name our-contact-first-name company-name])
      :report-id           selected-report-id
      :email-to            (:account/email their-contact)
      :send-email!         (fn [{:keys [msg on-success! on-error!]}]
                             (-> (conn/sendp! :kpi-category/request-revision msg)
                                 (p/then (fn [_]
                                           (on-success!)))
                                 (p/catch (fn [e]
                                            (on-error! e)
                                            (logging/error "send-reminder! failed" e)))))})))

(defn review-report!
  [report]
  (let [kpi-report-id (:db/id report)
        msg {:kpi-report-id kpi-report-id}]
    (-> (conn/sendp! :kpi-report/review msg)
        (p/then (fn [_]
                  (identity 'todo))) ;;do nothing for now
        (p/catch (fn [e]
                   (logging/error "review-report failed" e))))))

(defn unlock-report!
  [report]
  (let [kpi-report-id (:db/id report)
        msg {:kpi-report-id kpi-report-id}]
    (-> (conn/sendp! :kpi-report/activate msg)
        (p/then (fn [_]
                  (identity 'todo))) ;;do nothing for now
        (p/catch (fn [e]
                   (logging/error "activate-report failed" e))))))

(defn disable-kpi-report!
  [kpi-report]
  (let [kpi-report-id (:db/id kpi-report)
        company-id (:kpi-report/company kpi-report)
        msg {:kpi-report-id kpi-report-id}]
    (when kpi-report
      (-> (conn/sendp! :kpi-report/remove msg)
          (p/then (fn [_]
                      ;;leave report-id as selected-report. this shows an empty report data page
                  ))
          (p/catch (fn [e]
                     (logging/error "Remove report failed" e)))))))

(defn delete-selected-report!
  [selected-report]
  (modals/open-modal!
   delete-confirmation-modal/modal-key
   {:body       (loc/tr :kpi-report-delete)
    :on-delete! (fn [_] (disable-kpi-report! selected-report))}))

(defn submit-report!
  [report]
  (let [kpi-report-id (:db/id report)
        msg {:kpi-report-id kpi-report-id}]
    (-> (conn/sendp! :kpi-report/submit msg)
        (p/then (fn [_]
                  (modals/open-modal!
                   notification-modal/modal-key
                   {:body-text      (loc/tr :report-submitted-notification)
                    :ok-button-text (loc/tr :ok)})))
        (p/catch (fn [e]
                   (logging/error "submit-report failed" e))))))

(defn confirm-submit-report!
  [report]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:body           [:div
                     [:p (loc/tr :kpi-reports/confirm-submit-body)]]
    :confirm-text   (loc/tr :confirm)
    :confirm-icon   ""
    :title          (loc/tr :submit)
    :skip-checkbox? true
    :on-confirm     #(submit-report! report)}))

(defn array-data
  [kpi-report cycle]
  (let [kpi-report-id (:db/id kpi-report)
        kpi-report-datas (->> @session/all-kpi-report-datas
                              (cu/only-entity :kpi-report-data/kpi-report kpi-report-id)
                              (remove :common/disabled?))
        {:keys [kpi-cycle/target-month kpi-cycle/target-year]} cycle

        yperiods (cu/yperiods :monthly false target-year target-month)

        selected-kpis (fu/ordered-grouped-kpis kpi-report)
        user-guidances (-> kpi-report
                           :kpi-report/user-guidances)

        datas (->> kpi-report-datas
                   (map (fn [{:keys [kpi-report-data/year kpi-report-data/period
                                     kpi-report-data/kpi kpi-report-data/value]
                              :as   data}]
                          [[year period kpi] (fu/bigdec->float value)]))
                   (into {}))
        headers (concat [""]
                        (for [[y p] yperiods]
                          (str p "/" y)))
        rows (doall (for [kpi selected-kpis
                          :let [kw (:kw kpi)]]
                      (concat [(if (cu/separator-kw? kw)
                                 (get user-guidances kw)
                                 (fu/kpi-str kpi))]
                              (when-not (cu/separator-kw? (:kw kpi))
                                (for [[y p] yperiods]
                                  (get datas [y p kw]))))))]
    (concat [headers]
            rows)))

(defn quantitative-data
  [kpi-report]
  (let [kpi-report-id (:db/id kpi-report)
        kpi-report-answers (->> @session/all-kpi-report-answers
                                (cu/only-entity :kpi-report-answer/kpi-report kpi-report-id)
                                (remove :common/disabled?))
        {:keys [kpi-report/questions]} kpi-report
        user-guidances (:kpi-report/user-guidances kpi-report)
        selected-questions (fu/ordered-grouped-questions kpi-report)
        answers (->> kpi-report-answers
                     (map (fn [{:keys [kpi-report-answer/question
                                       kpi-report-answer/response]
                                :as   data}]
                            [question response]))
                     (into {}))]
    (for [question selected-questions
          :let [kw (:kw question)]]
      (if (cu/separator-kw? kw)
        [(get user-guidances kw)]
        [(fu/kpi-str question) (get answers kw)]))))

(defn internal-note-data
  [kpi-report]
  (let [internal-note (:kpi-report/internal-note kpi-report)]
    [(loc/tr :kpi-report/internal-note) internal-note]))

(defn export-file-name
  [kpi-report selected-cycle]
  (let [selected-category (get @session/entities (:kpi-cycle/kpi-category selected-cycle))
        selected-company (get @session/entities (:kpi-report/company kpi-report))
        selected-cycle (get @session/entities (:kpi-report/kpi-cycle kpi-report))]
    (loc/tr :export-filename-kpi-report
        [(:asset/name selected-company)
         (:kpi-cycle/name selected-cycle)])))

(defn report-data
  [kpi-report cycle]
  (let [val (array-data kpi-report cycle)
        qualitative val
        quantitative (quantitative-data kpi-report)
        internal-note (internal-note-data kpi-report)
        data (concat qualitative
                     [[]]
                     quantitative
                     (when-not (session/is-guest?)
                       [[] internal-note]))]
    data))

(defn export-to-excel
  [kpi-report cycle]
  (let [data (report-data kpi-report cycle)]
    (excel/export-array-data (export-file-name kpi-report cycle)
                             data)))

(defn- clipboard-data
  [kpi-report cycle]
  (let [data (array-data kpi-report cycle)]
    (string/join "\r\n"
                 (map (partial string/join "\t") data))))

(defn copy-to-clipboard
  [kpi-report cycle]
  (let [val (clipboard-data kpi-report cycle)
        qualitative val
        quantitative (string/join "\r\n"
                                  (map (partial string/join "\t") (quantitative-data kpi-report)))
        internal-note (string/join "\r\t" (internal-note-data kpi-report))
        data (string/join "\r\n"
                          [qualitative (when-not (session/is-guest?) internal-note) quantitative])]
    (clipboard/copy-to data)))

(defn add-attachment!
  [kpi-report e]
  (let [id (:db/id kpi-report)
        file (aget (:files e) 0)
        name (.-name file)
        attachment {:filename    name
                    :description nil
                    :file        file
                    :target      (:db/id kpi-report)}
        on-success! (fn [token]
                      (attachment-actions/*=>add-attachment
                       {:multipart-params (assoc attachment :token token)}
                       (fn [resp])
                       (partial logging/error "Error in uploading attachment")))]
    (common-actions/*<-create-op-token nil
                                       on-success!
                                       (partial logging/error "resp token="))))

(defn remove-attachment!
  [target attachment]
  (attachment-actions/*<-remove-attachment
   {:target-id (:db/id target) :attachment-id (:db/id attachment)}
   (partial logging/unimplemented "remove-attachment! Success")
   (partial logging/error "remove-attachment! failed")))
